import { ApiSuccess } from "ui/Scripts/source/models/common/apiSuccess";
import { Base } from "ui/Scripts/source/framework/base";
import { MessageEdit } from "../message/messageEdit";
import { MessageList } from "../message/messageList";
import { postApiCall, getApiCall } from "./tokenService";

export const getMessageList = (page: number, startDate: number, endDate: number, companyId: string): Promise<MessageList> => {
    return getApiCall<MessageList>("api/message?page=" + page +
        "&startDate=" + (!Base.isNullOrUndefined(startDate) ? startDate : "") +
        "&endDate=" + (!Base.isNullOrUndefined(endDate) ? endDate : "") +
        "&companyId=" + (!Base.isNullOrUndefined(companyId) ? companyId : ""), MessageList);
};

export const messageListRefresh = (page: number, startDate: number, endDate: number, companyId: string): Promise<MessageList> => {
    return getApiCall<MessageList>("api/message/refresh?page=" + page +
        "&startDate=" + (!Base.isNullOrUndefined(startDate) ? startDate : "") +
        "&endDate=" + (!Base.isNullOrUndefined(endDate) ? endDate : "") +
        "&companyId=" + (!Base.isNullOrUndefined(companyId) ? companyId : ""), MessageList);
};

export const getMessageEdit = (id: string): Promise<MessageEdit> => {
    return getApiCall<MessageEdit>("api/message/item?id=" + id, MessageEdit);
};

export const sendMessageReadReceipt = (id: string, companyId: string, category: number): Promise<ApiSuccess> => {
    return postApiCall<ApiSuccess>("api/message/receipt?id=" + id + "&companyId=" + companyId + "&category=" + category.toString(10), ApiSuccess);
};